import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDialog } from "../../../../contexts/DialogContext";
import { useTranslation } from "react-i18next";

import {
  Card,
  Grid,
  CardHeader,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Button,
  Typography,
  CardContent,
  Box,
} from "@mui/material";
import styled from "@emotion/styled";
import { spacing } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import Toolbar from "../../../../components/Toolbar";
import useWindowDimensions from "../../../../utils/windowDimensions";
import useEmailToTenant from "../../../../hooks/useEmailToTenant";
import useTenant from "../../../../hooks/useTenant";
import AdvanceFilter from "./AdvanceFilter";
import useMainContentDimensions from "../../../../utils/mainContentDimensions";
import SendMail from "./SendMail";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);
const Paper = styled(MuiPaper)(spacing);

function CustomDataGrid(props) {
  const { isLoadingDownload, downloadFileType } = useTenant();
  const { width: mainContentWidth } = useMainContentDimensions();

  const { state } = useLocation();
  const { t } = useTranslation();
  const { addPage, refreshPage, setFilterResetFunc } = props;
  const [selectedRows, setSelectedRows] = useState([]);

  const addTo = (id) => {
    return openDialog("send_mail", "Send Mail", <SendMail selectedRows={selectedRows} />);
  };

  const currentPayload = {
    pagination: {
      pageNumber: 1,
      pageSize: 100,
    },
  };

  const [sortModel, setSortModel] = useState([
    {
      field: "updatedAt",
      sort: "desc",
    },
  ]);
  const { height } = useWindowDimensions();
  const { getAllTenant, tenants, paging, id, downloadFile } = useTenant();
  const { openDialog } = useDialog();

  const [payload, setPayload] = useState(currentPayload);

  const onPageChange = (page) => {
    console.log(page, "pagepage");
    const pagination = {
      pageNumber: page == 0 ? 1 : page + 1,
      pageSize: payload.pagination.pageSize,
    };
    setPayload((prev) => ({ ...prev, pagination }));
  };

  const breadCrump = () => {
    return (
      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Typography>Email</Typography>
        <Typography>Tenant</Typography>
      </Breadcrumbs>
    );
  };

  const handleSortModelChange = (newModel) => {
    console.log(newModel, "newModel");
    if (newModel.length !== 0) {
      setSortModel(newModel);
      setPayload((prev) => ({ ...prev, sortFields: newModel }));
    }
  };

  const handleSelectedRows = (GridSelectionModelChangeParams) => {
    let selectedValues = [];
    if (Array.isArray(GridSelectionModelChangeParams)) {
      GridSelectionModelChangeParams.forEach((selection_index) => {
        const filteredValues = tenants.filter(function (data) {
          return data.tenantId === selection_index;
        });
        selectedValues = [...selectedValues, ...filteredValues];
      });
    }
    setSelectedRows(selectedValues);
  };

  const columns = [
    {
      field: "tenantName",
      headerName: "Franchise Name",
      width: 300,
    },
    {
      field: "userName",
      headerName: "User Name",
      width: 300,
    },
    {
      field: "emailId",
      headerName: "Mail Id",
      width: 300,
    },
    {
      field: "mobileNo",
      headerName: "Mobile No",
      width: 150,
    },
  ];

  const openFilterDialog = () => {
    return openDialog(
      "advance_filter",
      "Advance Filter",
      <AdvanceFilter
        payload={payload}
        setPayload={setPayload}
        setFilterResetFunc={setFilterResetFunc}
      />,
    );
  };

  return (
    <Card sx={{ width: "100%", maxWidth: mainContentWidth - 64 }}>
      <CardHeader
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" }, // Stack on small screens
          justifyContent: "space-between",
          alignItems: "flex-start", // Adjust alignment as needed
        }}
        action={
          <Toolbar
            addPage={addPage}
            downloadFile={downloadFile}
            refreshPage={refreshPage}
            openFilterDialog={openFilterDialog}
            isLoadingDownload={isLoadingDownload}
            downloadFileType={downloadFileType}
            addSmsAndEmailPage={addTo}
          />
        }
        title={
          <Typography variant="h6" sx={{ fontSize: { xs: "1.25rem", sm: "1.5rem" } }}>
            {t("email_to_franchise")}
          </Typography>
        }
        subheader={<Box sx={{ display: "flex", flexWrap: "wrap" }}>{breadCrump()}</Box>}
      />
      <CardContent sx={{ height: height - 180, display: "flex", flexDirection: "column" }}>
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <DataGrid
            columns={columns}
            rows={tenants}
            getRowId={(row) => row["tenantId"]}
            rowCount={paging.totalNumberOfRecords}
            loading={false}
            rowsPerPageOptions={[5]}
            pagination
            page={paging.pageNumber}
            pageSize={paging.pageSize}
            paginationMode="server"
            onPageChange={(page) => onPageChange(page)}
            onPageSizeChange={(pageSize) => onPageChange(pageSize)}
            checkboxSelection
            sortingMode="server"
            sortModel={sortModel}
            onSortModelChange={handleSortModelChange}
            onRowSelectionModelChange={(newRowSelectionModel) => {
              const selectedRowData = tenants.filter((row) =>
                newRowSelectionModel.includes(row.tenantId),
              );

              setSelectedRows(selectedRowData);
            }}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
            }
            sx={{
              "& .MuiDataGrid-row.even-row": {
                backgroundColor: "#f9f9f9", // Light gray for even rows
              },
              "& .MuiDataGrid-row.odd-row": {
                backgroundColor: "#ffffff", // White for odd rows
              },
            }}
          />
        </Box>
      </CardContent>
    </Card>
  );
}

export default CustomDataGrid;
